import { Chat } from 'models/chat';

export const findChatTypeById = (state, chatId) => {
  const chats: Chat[] = Object.values(state.entities.userChats.data);
  return chats.find(chat => chat.id === chatId)?.marker;
};
